enum visualType {
    GESTURES= "Gestures",
    SIGN_LANGUAGE = "Sign Language",
    WRITTEN = "Written",
    PICTURE_CARDS = "Picture cards",
  }
  
  export default visualType;
  